import React from 'react'
import { Box, Grid2 as Grid, Divider } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import EngagementScoreCard from './EngagementScoreCard'
import MetricCard from './MetricCard'
import { AnalyticsMetric } from '../../../types/Metrics'
import { Theme } from '@mui/system'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.background.paper,
    minWidth: 241, // 1px border.
  },
  toggleButton: {
    margin: theme.spacing(0, 0.5),
  },
  cardsContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
  },
}))

interface MetricListProps {
  metrics: AnalyticsMetric[]
  variant?: 'row' | 'grid'
}

interface MetricListItemProps {
  metric: AnalyticsMetric
  compact: boolean
}

const MetricListItem = ({ metric, compact }: MetricListItemProps) => {
  // FIXME: Would be nice to have MetricCard to support such cases as well or another approach to avoid this condition
  if (metric.id === 'engagement-health-score') {
    return <EngagementScoreCard compact={compact} />
  }

  return <MetricCard compact={compact} {...metric} />
}

export const MetricList = ({ metrics, variant = 'row' }: MetricListProps) => {
  const classes = useStyles()
  const isGrid = variant === 'grid'

  return isGrid ? (
    <Grid container spacing={2}>
      {metrics.map((metric: AnalyticsMetric) => (
        <Grid size={{ xs: 12, sm: 6 }} key={metric.id}>
          <MetricListItem metric={metric} compact={false} />
        </Grid>
      ))}
    </Grid>
  ) : (
    <Box className={classes.root}>
      <Box className={classes.cardsContainer}>
        {metrics.map((metric: AnalyticsMetric, i: number) => (
          <React.Fragment key={metric.id}>
            <MetricListItem metric={metric} compact />
            {i < metrics.length - 1 && <Divider orientation="vertical" flexItem />}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  )
}
